// extracted by mini-css-extract-plugin
export default {"footerContainer":"AcceptAgreementPopup_footerContainer__EWs0i"};